import { Component } from "vue-property-decorator";
import { VueWizard } from "@/vue-wizard";
import moment from "moment";

@Component({
  name: "chatea-pro-redirect",
  components: {},
})
export default class ChateaProRedirect extends VueWizard {
  get currentYear(): string {
    return moment().format("YYYY");
  }
}
